// ** Dropdowns Imports
import UserDropdown from './UserDropdown';

// ** Reactstrap Imports
import IntlDropdown from './IntlDropdown';
import { useProfile } from '../../../../../store/Auth/authHooks';

const NavbarUser = (props) => {
  // ** Props
  const user = useProfile();

  return (
    <ul className="nav navbar-nav align-items-center ms-auto">
      <IntlDropdown />
      <UserDropdown user={user} />
    </ul>
  );
};
export default NavbarUser;
